import { useEffect, useState, useCallback } from 'react'

const useMediaQuery = (queries: any, values: any, defaultValue: any) => {
  const mediaQueryLists = queries.map((q: any) => window.matchMedia(q))

  const getValue = useCallback(() => {
    const index = mediaQueryLists.findIndex((mql: any) => mql.matches)
    return typeof values[index] !== 'undefined' ? values[index] : defaultValue
  }, [values, defaultValue, mediaQueryLists])

  const [value, setValue] = useState(getValue)

  useEffect(() => {
    const handler = () => setValue(getValue)
    mediaQueryLists.forEach((mql: any) => mql.addListener(handler))
    return () =>
      mediaQueryLists.forEach((mql: any) => mql.removeListener(handler))
  }, [getValue, mediaQueryLists])

  return value
}

export default useMediaQuery
